import { blue, green, orange, purple } from '@ant-design/colors';
import { z } from 'zod';

export type VendaTipoItem = {
    key: string;
    value: string;
    label: string;
    artigo: string;
    artigoPlural: string;
    plural: string;
    crase: 'ao' | 'à';
    color: string;
};

export const VENDA_TIPO: VendaTipoItem[] = [
    {
        artigo: 'o',
        artigoPlural: 'os',
        color: blue.primary || '',
        crase: 'ao',
        key: 'pedido',
        label: 'Pedido',
        plural: 'pedidos',
        value: 'pedido',
    },
    {
        artigo: 'a',
        artigoPlural: 'as',
        color: orange.primary || '',
        crase: 'à',
        key: 'bonificação',
        label: 'Bonificação',
        plural: 'bonificações',
        value: 'bonificação',
    },
    {
        artigo: 'o',
        artigoPlural: 'os',
        color: purple.primary || '',
        crase: 'ao',
        key: 'orçamento',
        label: 'Orçamento',
        plural: 'orçamentos',
        value: 'orçamento',
    },
    {
        artigo: 'a',
        artigoPlural: 'as',
        color: green.primary || '',
        crase: 'à',
        key: 'venda',
        label: 'Venda',
        plural: 'vendas',
        value: 'venda',
    },
];

export const VendaTipoSchema = z.enum(['pedido', 'bonificação', 'orçamento', 'venda']);

export type VendaTipo = z.infer<typeof VendaTipoSchema>;
